// removed by extract-text-webpack-plugin
module.exports = {"carousel-indicator":"HorizontalSlider__carousel-indicator__16vkz","navigation":"HorizontalSlider__navigation__1awuQ","left":"HorizontalSlider__left__3bhmX","right":"HorizontalSlider__right__20rV8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HorizontalSlider/HorizontalSlider.scss
// module id = 441
// module chunks = 0